<template>
  <main role="main">

    <section class="jumbotron text-center" style="width: 100%; display: flex; justify-content: center;">
      <div style="width: 90%; margin-top: -1cm">

        <div class="title1">双色球</div>

        <p class="lead text-muted m-3 text-left">
          游戏规则说明：
          6个红球+1个蓝球 ，奖励积分1000万。
          6个红球+0个蓝球，奖励积分500万。
          5个红球+1个蓝球，奖励积分3000。
          5个红球+0个蓝球，或者4个红球+1个蓝球，奖励积分200。
          4个红球+0个蓝球，或者3个红球+1个蓝球，奖励积分10。
          小于3个红球+1个蓝球，奖励积分5。
          如果前面的都不成立，就感谢您的参与，扣取1分，可以在页面下方查看历史战绩，重整旗鼓再开始。
        </p>
        <hr>

        <div>
          <el-table :data="resultList">
            <el-table-column label="开奖结果" prop="radius"></el-table-column>
            <el-table-column label="积分情况" prop="count"></el-table-column>
          </el-table>
        </div>
        <p>
          <br>
        </p>

        <hr>

        <div>
          <p class="lead text-muted m-3 text-left">
            红色球选6个：
          </p>
        </div>

        <el-checkbox-group v-model="redCheckList" class="checkbox-left-align" @change="handleCheckChange">
          <el-checkbox v-for="item in checkboxItems33" :key="item.label" :label="item.label"></el-checkbox>
        </el-checkbox-group>

        <hr>

        <div>
          <p class="lead text-muted m-3 text-left">
            蓝色球选1个：
          </p>
        </div>

        <el-checkbox-group v-model="blueCheckList" class="checkbox-left-align" @change="handleSingleSelect">
          <el-checkbox v-for="item in checkboxItems16" :key="item.label" :label="item.label"></el-checkbox>
        </el-checkbox-group>

        <p>
          <br>
        </p>

        <div class="input-with-button-container">
          <el-button type="primary" @click="reset" size="medium">重置</el-button>
          <el-button type="primary" @click="send" size="medium">开始游戏</el-button>
        </div>

        <p>
          <br>
        </p>

        <hr>

        <div class="input-with-button-container">
          <el-button type="primary" @click="historyUnionLotto" size="medium">查看历史战绩</el-button>
        </div>

        <p>
          <br>
        </p>

        <div>
          <el-table :data="historyUnionLottoList" style="width: 100%">
<!--            //生成自增序号-->
            <el-table-column
                label="序号"
                width="100">
              <template slot-scope="scope">
                {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="期数" prop="id" width="100"></el-table-column>
            <el-table-column label="投注用户ID" prop="memberId" width="100"></el-table-column>
            <el-table-column label="开奖时间" prop="createTime" width="200"></el-table-column>
            <el-table-column label="用户的投注" prop="userChoice"></el-table-column>
            <el-table-column label="开奖结果" prop="systemChoice"></el-table-column>
            <el-table-column label="积分情况" prop="points"></el-table-column>
          </el-table>
        </div>

        <div class="block">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size=pageSize
              layout="total, prev, pager, next"
              :total=total>
          </el-pagination>
        </div>

      </div>
    </section>
  </main>
</template>

<script>

import TheCourse from "../components/the-course";

export default {
  name: 'unionLotto',
  components: {TheCourse},
  data: function () {
    return {
      currentPage: 1, // 当前页码
      pageSize: 5, // 每页显示的条数
      total:'',
      resultList: [],
      redCheckList: [],
      blueCheckList: [],
      historyUnionLottoList:[],
      checkboxItems33: Array.from({length: 33}, (_, index) => ({
        //生成一共1-33的数组，上面通过v-for循环遍历
        label: (index + 1).toString()
      })),

      checkboxItems16: Array.from({length: 16}, (_, index) => ({
        //生成一共1-33的数组，上面通过v-for循环遍历
        label: (index + 1).toString()
      })),
      maxCheckedCount33: 6,
      maxCheckedCount16: 1,
      memberInfo: [],
      tableData: [],
      queryParams: {
        textValue: '',
      },
    }
  },
  created() {
    let _this = this;
    _this.historyUnionLotto();
  },

  mounted() {
    let _this = this;
    // _this.getMemberInfo();
  },

  methods: {
    //红球校验
    handleCheckChange(newList) {
      if (newList.length > this.maxCheckedCount33) {
        this.$message.error('最多只能选择6项');
        newList.pop(); // 移除最后一个被选中的项
        this.redCheckList = [...newList];
      } else {
        this.redCheckList = [...newList];
      }
    },

    //蓝色球校验
    handleSingleSelect(newVal) {

      if (newVal.length > this.maxCheckedCount16) {
        this.$message.error('最多只能选择1项');
        newVal.pop(); // 移除最后一个被选中的项
        this.blueCheckList = [...newVal];
      } else {
        this.blueCheckList = [...newVal];
      }
    },


    getMemberInfo() {
      let _this = this;
      let loginMember = Tool.getLoginMember();
      if (Tool.isEmpty(loginMember)) {
        // Toast.warning("请先登录");
        return;
      }
      _this.queryParams.id = loginMember.id;
      console.log("queryParams:", _this.queryParams.id);
      _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/member/getInfoById',
          _this.queryParams).then((response) => {
            console.log("开始游戏：", response);
            _this.memberInfo = response.data;
          },
      )
    },

    send() {
      let _this = this;
      let loginMember = Tool.getLoginMember();
      if (Tool.isEmpty(loginMember)) {
        Toast.warning("请先登录");
        return;
      }
      _this.getMemberInfo();
      _this.queryParams.memberId = loginMember.id;
      _this.queryParams.red = _this.redCheckList.join(',');
      _this.queryParams.blue = _this.blueCheckList.toString();
      _this.queryParams.blue = _this.blueCheckList.toString();
      let queryParamsRed = _this.queryParams.red;
      let queryParamsBlue = _this.queryParams.blue;
      if (Tool.isEmpty(queryParamsRed)) {
        Toast.warning("请先选择您的红球号码~");
        return;
      }
      if (Tool.isEmpty(queryParamsBlue)) {
        Toast.warning("请先选择您的蓝球号码~");
        return;
      }
      console.log("queryParams:", _this.queryParams);
      _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/pointGame/unionLotto',
          _this.queryParams).then((response) => {
            console.log("双色球：", response);
            _this.resultList = response.data;
            _this.historyUnionLotto();
          },
      )
    },

    historyUnionLotto() {
      let _this = this;
      let loginMember = Tool.getLoginMember();
      // if (Tool.isEmpty(loginMember)) {
      //   Toast.warning("请先登录");
      //   return;
      // }
      _this.getMemberInfo();
      _this.queryParams.memberId = loginMember.id;
      _this.queryParams.page = _this.currentPage;
      _this.queryParams.pageSize = _this.pageSize;
      console.log("queryParams:", _this.queryParams);
      _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/pointGame/listUnionLotto',
          _this.queryParams).then((response) => {
            console.log("双色球：", response);
            _this.historyUnionLottoList = response.data.records;
            _this.total= response.data.total;
          },
      )
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      let _this = this;
      _this.page=val;
      _this.historyUnionLotto()
      console.log(`当前页: ${val}`);
    },

    reset(){
      let _this = this;
      _this.redCheckList = [];
      _this.blueCheckList = [];
    },

  }
}
</script>

<style>
.title1 {
  margin-bottom: 2rem;
  color: #fafafa;
  letter-spacing: 0;
  text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
  font-size: 2rem;
}

.title2 {
  margin-bottom: 2rem;
  color: transparent;
  -webkit-text-stroke: 1px black;
  letter-spacing: 0.04em;
  font-size: 2rem;
}

.title {
  margin-bottom: 10px;
  font-size: 30px;
  color: #333;
  text-align: center;
}

.input-with-button-container {
  display: flex;
  align-items: center; /* 确保元素垂直居中对齐 */
  gap: 8px; /* 在两个元素间创建2字符（可以调整为所需的像素值）的间距 */
}

.checkbox-left-align {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

</style>
